import _ from 'lodash';
import { dates } from '@unite-us/app-components';

export function getOutcomeData(item) {
  return [
    {
      label: 'Outcome',
      value: !item.outcome ?
        _.get(item, 'case.outcome.description', '') : _.get(item, 'outcome.description', ''),
    },
  ];
}

export function getResolutionAndUpdatedData(item, closingTime) {
  const outcomeResolution = !item.outcome ?
    _.get(item, 'case.outcome.resolved', false) : _.get(item, 'outcome.resolved', false);
  return [
    {
      label: 'Resolution',
      value: outcomeResolution ? 'Resolved' : 'Unresolved',
    },
    {
      label: 'Updated At',
      value: closingTime && dates.formatLocalDateTime(closingTime),
    },
  ];
}

export function getClosedDateData(closedDate) {
  return [
    {
      label: 'Closed Date',
      value: closedDate && dates.formatLocalDateTime(closedDate),
    },
  ];
}
